/**
 * 获取播放器内核
 * 参考 tv-linux 项目的 getInitPlayerKernel() 函数
 */

import { useAppStore } from '@/stores/appStore';

/**
 * 获取不同设备默认的播放内核
 * @returns 'hls.js' | 'origin'
 */
export function getInitPlayerKernel(): 'hls.js' | 'origin' {
  if (typeof window === 'undefined') return 'hls.js';

  // 如果本地有，则取本地的
  const storedPlayerKernel = localStorage.getItem('playerKernel');
  if (storedPlayerKernel && (storedPlayerKernel === 'hls.js' || storedPlayerKernel === 'origin')) {
    return storedPlayerKernel;
  }

  // 本地没有，根据设备进行判断，取最适配的
  // 从 appStore 获取渠道号
  const vChannelId = useAppStore.getState().vChannelId || '';

  // 简化版判断逻辑（原项目有更复杂的设备检测）
  // 如果渠道号是 16600 或 16599，使用原生内核
  const isOrigin = vChannelId === '16600' || vChannelId === '16599';

  // 通过渠道号判断，如果是特定设备使用原生内核
  if (isOrigin) return 'origin';

  // 默认使用 hls.js
  return 'hls.js';
}
